var exports = {
  "X7": "UserProfileBadges.module__containerModal___ajZsQ3",
  "j4": "UserProfileBadges.module__containerModalMobile___ajZsQ3",
  "pP": "UserProfileBadges.module__containerModalDesktop___ajZsQ3",
  "RS": "UserProfileBadges.module__containerPopout___ajZsQ3",
  "Qk": "UserProfileBadges.module__badgeMobile___ajZsQ3",
  "EJ": "UserProfileBadges.module__badgeDesktop___ajZsQ3",
  "X8": "UserProfileBadges.module__sequenceBadge___ajZsQ3",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___ajZsQ3",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___ajZsQ3",
  "nf": "UserProfileBadges.module__link___ajZsQ3",
  "$J": "UserProfileBadges.module__linkButton___ajZsQ3",
};

module.exports = exports;
